module.exports = __webpack_public_path__ + "img/patientInfo.af06deff.png";